import { BREAKPOINTS, COLORS, SystemIcons } from '@laerdal/life-react-components';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import posthog from 'posthog-js';

const Container = styled.a`
  display: flex;
  
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: ${COLORS.neutral_20};
  cursor: pointer;
  text-decoration: none;

  ${BREAKPOINTS.MEDIUM} {
    padding: 16px 32px;
  }

  &:hover {
    background: ${COLORS.neutral_50};
  }
`;

const IconCircle = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  aspect-ratio: 1/1;
  border-radius: 1000px;
  background: var(--life-color-bg-surface-primary);

  svg {
    stroke: ${COLORS.primary_500};
    fill: none;
  }
`;

const Title = styled.span`
  color: var(--life-color-text-default);
  font-feature-settings: 'liga' off;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  flex: 1;
`;

const StyledLink = styled.a`
    display: none;
    gap: 4px;
    color: var(--life-color-text-primary);
    text-align: center;
    font-feature-settings: 'liga' off;
    /* Components/Bold/M */
    font-family: var(--font-family-Lato, Lato);
    font-size: var(--font-size-14, 18px);
    font-style: normal;
    font-weight: var(--font-weight-bold, 700);
    line-height: var(--line-height-5, 24px); /* 133.333% */
    text-decoration: none;

  ${BREAKPOINTS.MEDIUM} {
    display: flex;
  }

  &:hover {
    text-decoration: underline;
  }
`;

const MobileChevron = styled.span`
  display: flex;
  align-items: center;
  color: var(--life-color-text-primary);

  ${BREAKPOINTS.MEDIUM} {
    display: none;
  }
`;

const PartsAndAccessories = () => {
    const { t } = useTranslation("cases");
    //@ts-ignore
    const ecommerceBase = process.env?.REACT_APP_ECOMMERCE_BASE || '';
    const link = `${ecommerceBase}/shop/?category=PartsAndAccessories&sortBy=0`;

    return (
        <Container href={link} target="_blank" rel="noopener noreferrer" onClick={() => posthog.capture('SUPP-Casedeflection-Parts&Accessories')}>
            <IconCircle>
                <SystemIcons.ShoppingCart size="20px" color={COLORS.primary_500} />
            </IconCircle>
            <Title>{t("Parts and accessories")}</Title>
            <StyledLink as="span">
                {t("Go to parts and accessories")}
                <SystemIcons.ArrowLineRight size="24px" />
            </StyledLink>
            <MobileChevron>
                <SystemIcons.ChevronRight size="24px" />
            </MobileChevron>
        </Container>
    );
};

export default PartsAndAccessories;
